import { EboObject } from '../base-classes/ebo-object';
import { Company } from '../organization/company/company';
import { AssetAssignment } from './asset-assignment';

export class Asset extends EboObject {
  name: string;
  companyID: string;
  company: Company;
  model: string;
  description: string;
  assignments: AssetAssignment[];

  constructor(jsonData?: Partial<Asset>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.company) {
        this.company = new Company(jsonData.company);
      }
      if (jsonData.assignments) {
        this.assignments = jsonData.assignments
          .map((data: Partial<AssetAssignment>) => {
            return new AssetAssignment(data);
          })
          .sort((e1, e2) => (e1.startTime.isBefore(e2.startTime) ? -1 : 1));
      }
    }
    this.assignments ??= [];
  }

  toShortString(): string {
    return `${this.company ? this.company.name : 'Unk'}-${this.name}`;
  }
}
